import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function Danke() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0E0F12] px-6 text-center">
      <CheckCircle2 className="mb-6 text-[#3DDC97]" size={56} />
      <h1 className="font-display text-3xl font-bold text-white md:text-4xl">Vielen Dank!</h1>
      <p className="mt-4 max-w-md text-[15px] leading-relaxed text-gray-400">
        Ihre Anfrage ist bei uns eingegangen. Wir melden uns zeitnah mit einer
        ehrlichen Einschätzung für Ihren Betrieb.
      </p>
      <Link
        to="/"
        data-testid="danke-home-btn"
        className="mt-8 rounded-md border border-white/15 px-6 py-3 text-sm font-medium text-gray-200 hover:bg-white/5"
      >
        Zurück zur Startseite
      </Link>
    </div>
  );
}
